import APICall from '$ReduxLegacy/Actions/APICall';
import Unireducer from '$ReduxLegacy/Reducers/Factories/Unireducer';

export const getConsents = () => dispatch => {
    return dispatch(
        APICall({
            type: 'GET',
            url: '/api/v2/intake/agreements/'
        })
    ).then(data => {
        const consents = data.response;
        if (!consents) {
            return dispatch({
                type: '@@DYNAMIC_CONSENTS/CHANGE',
                payload: 'error'
            });
        }
        const activeConsent = consents.length === 0 ? 'complete' : consents[0];
        return dispatch({
            type: '@@DYNAMIC_CONSENTS/CHANGE',
            payload: activeConsent
        });
    });
};

export const submitConsent = (id, accepted) => dispatch => {
    return dispatch(
        APICall({
            type: 'POST',
            url: `/api/v2/intake/agreements/${id}/agree/`,
            data: { accepted }
        })
    ).then(data => {
        if (data.type.includes('SUCCESS')) {
            return getConsents()(dispatch);
        }
        return data;
    });
};

const initialState = null;

export default Unireducer('@@DYNAMIC_CONSENTS', initialState);
